import styled from '@emotion/styled';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import { Link } from 'react-router';

import { ApplicationContext } from '~/shared/context/context';
import { Tooltip } from '~/ui/core/tooltip/Tooltip';

const LogoImage = styled.img({
    width: '100px',
});

const appVersion = import.meta.env.APP_VERSION;

export const CompanyLogoV2: FunctionComponent = () => {
    const { applicationState } = useContext(ApplicationContext);
    const companyLogoUrl = applicationState.customization.get('uiConfiguration').get('assets').get('companyLogoUrl');
    const showDeployedVersion = applicationState.featureFlagService.isFeatureFlagEnabled('show-deployed-version');

    if (companyLogoUrl.isJust) {
        const logoLink = (
            <Link to="/">
                <LogoImage alt="Company logo" src={companyLogoUrl.value.href} />
            </Link>
        );

        if (showDeployedVersion) {
            return (
                <Tooltip>
                    <Tooltip.Trigger asChild={true}>{logoLink}</Tooltip.Trigger>
                    <Tooltip.Portal>
                        <Tooltip.Content side="bottom" sideOffset={20}>
                            {appVersion}
                        </Tooltip.Content>
                    </Tooltip.Portal>
                </Tooltip>
            );
        }

        return logoLink;
    }

    return null;
};
